/**
 * WidgetCard — wrapper de cada widget no grid.
 *
 * - Header sempre visivel com title + handle de drag (modo edicao)
 * - Body renderiza o componente do widget OU skeleton/erro
 * - Em modo edicao: handle visivel (drag) + botao remover
 * - Em modo leitura: card limpo, sem handles
 *
 * dnd-kit `useSortable` cuida do drag-and-drop quando `sortableEnabled`.
 */
import React from "react";
import { FiMove, FiX } from "react-icons/fi";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import {
  Card,
  CardActions,
  CardHeader,
  CardTitle,
  DragHandle,
  ErroInline,
  RemoveButton,
  Skeleton,
} from "./styles";


function SkeletonBody() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <Skeleton $h="1.4em" $w="60%" />
      <Skeleton $h="0.9em" $w="40%" />
    </div>
  );
}


export default function WidgetCard({
  widget,
  contexto,
  dados,
  loading,
  error,
  modoEdicao,
  onRemover,
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: widget.id, disabled: !modoEdicao });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const Componente = widget.def.Componente;

  return (
    <Card
      ref={setNodeRef}
      style={style}
      $editando={modoEdicao}
      $dragging={isDragging}
    >
      <CardHeader>
        <CardTitle title={widget.def.descricao || widget.def.label}>
          {widget.def.label}
        </CardTitle>
        {modoEdicao && (
          <CardActions>
            <DragHandle
              type="button"
              aria-label={`Mover ${widget.def.label}`}
              {...attributes}
              {...listeners}
            >
              <FiMove size={14} aria-hidden="true" />
            </DragHandle>
            <RemoveButton
              type="button"
              aria-label={`Remover ${widget.def.label}`}
              onClick={() => onRemover(widget.id)}
            >
              <FiX size={14} aria-hidden="true" />
            </RemoveButton>
          </CardActions>
        )}
      </CardHeader>

      {loading && !dados ? (
        <SkeletonBody />
      ) : error ? (
        <ErroInline>
          Erro: {error}. <em>Sera tentado novamente em 60s.</em>
        </ErroInline>
      ) : (
        <Componente
          dados={dados}
          loading={loading}
          error={error}
          contexto={contexto}
        />
      )}
    </Card>
  );
}
